'use client';
import { scrollUpVariants } from '@rocket-house-productions/util';
import { motion } from 'framer-motion';
import StatsItem from './stats-item';
import SectionTitle from '../section-title/section-title';
import cn from 'classnames';

const AnimatedSectionTitle = motion.create(SectionTitle);
const AnimatedStatsFact = motion.create(StatsItem);

type SectionStatsProps = {
  data: {
    title?: any;
    category?: any;
    body?: any;
    items?: any[];
  };
};

export function SectionStats({ data: { title, category, body, items } }: SectionStatsProps) {
  if (!items?.length) {
    return;
  }

  return (
    <div>
      {title && (
        <AnimatedSectionTitle
          title={title}
          subtitle={category}
          description={body}
          titleSize="large"
          className="mb-7.5 md:mb-15"
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: true, amount: 0.4 }}
          variants={scrollUpVariants}
        />
      )}
      <div
        className={cn(
          'mx-auto grid gap-[30px]',
          items?.length > 4 ? 'md:grid-cols-4' : 'md:grid-cols-' + items?.length,
        )}>
        {items?.map(
          item =>
            (item.counter || item.title) && (
              <AnimatedStatsFact
                key={item.title.replace(/\s/g, '-').toLowerCase()}
                counter={Number(item.counter)}
                suffix={item.suffix}
                title={item.title}
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, amount: 0.4 }}
                variants={scrollUpVariants}
              />
            ),
        )}
      </div>
    </div>
  );
}

export default SectionStats;
